export default __webpack_public_path__ + "static/media/Times Square.5f73fa45.jpg";